import ApiDefault from "../../ApiDefault";

export default function ApiOrdersTypes() {
    const apiDefault = ApiDefault("v2/basics/orders-types");
    
    return {
        apiDefault,
    };
}
